import { render, staticRenderFns } from "./Besturen.vue?vue&type=template&id=4b022c46&"
import script from "./Besturen.vue?vue&type=script&lang=js&"
export * from "./Besturen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports